import { useEffect } from "react";

// Inconsistencia reportada 2026-07-29 (Juan Cruz): la HCE, si ya está
// abierta mientras dura la videollamada (Room.js flota por encima de
// cualquier página), no se enteraba de una evolución/archivo agregado
// desde el piloto in-call (meet/www/script.js) hasta un refresh manual.
// meet monta su script directo en este mismo window (sin iframe), así que
// un evento global alcanza.
// Code review 2026-07-30: extraído a un hook único — esta misma lógica
// vivía duplicada palabra por palabra en EHR.js (v1) y EHR/V2/EHR.js; un
// cambio futuro al contrato del evento (nombre, prefijo, guard) tenía
// antecedente concreto de aplicarse a una sola de las dos copias,
// reintroduciendo en silencio el mismo bug en la vista que se salteara.
const useRecordSavedListener = (consumerID, refetch) => {
  useEffect(() => {
    const onRecordSaved = e => {
      const savedConsumerID = e.detail?.consumerID?.replace(/^consumers\//, "");
      if (savedConsumerID && savedConsumerID === consumerID) {
        refetch();
      }
    };
    window.addEventListener("drapp:record-saved", onRecordSaved);
    return () => window.removeEventListener("drapp:record-saved", onRecordSaved);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [consumerID]);
};

export default useRecordSavedListener;
